var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"md-layout-header"},[_c('md-shared-header')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }